// src/utils/storage.js - sessionStorage helpers that never throw.
// Private windows, blocked site data or a full quota make the Storage API throw;
// losing a draft must never break the page.

export function readJSON(key, storage = 'session') {
  try {
    const store = storage === 'local' ? window.localStorage : window.sessionStorage;
    const raw = store.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function writeJSON(key, value, storage = 'session') {
  try {
    const store = storage === 'local' ? window.localStorage : window.sessionStorage;
    store.setItem(key, JSON.stringify(value));
  } catch (e) {
    /* ignore */
  }
}

export function removeKey(key, storage = 'session') {
  try {
    const store = storage === 'local' ? window.localStorage : window.sessionStorage;
    store.removeItem(key);
  } catch (e) {
    /* ignore */
  }
}
